import {RouteProps} from 'react-router-dom'
import {Measures} from '@pages/measures/Measures.tsx'
import {MeasureDetails} from '@pages/measure-details/MeasureDetails.tsx'
import {MeasuresResult} from '@pages/measures-result/MeasuresResult.tsx'
import {MeasureRaw} from '@pages/measure-raw/MeasureRaw.tsx'

export const routes = {
    MEASURES: {
        path: '/',
        element: <Measures />
    },
    MEASURE_DETAILS: {
        path: 'measure/:id',
        element: <MeasureDetails />
    },
    MEASURE_RESULTS: {
        path: 'search',
        element: <MeasuresResult />
    },
    MEASURE_RAW: {
        path: '/:id',
        element: <MeasureRaw />
    }
} as const satisfies Record<string, RouteProps>
